import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { GetAllRequestResponse } from '@modules/regular-user/requests/domain';
import {
  Client,
  GetClientsResponse,
  GetMemberResponse,
  Member,
  RemoveAndAssignRequest,
} from '../entities';

@Injectable()
export abstract class ClientsServices {
  /**
   * All Clients
   */
  abstract getAllClients(companyId: string): Observable<GetClientsResponse>;
  /**
   * Client By Id
   */
  abstract getClientById(clientId: string): Observable<GetClientsResponse>;
  /**
   * Remove Client
   */
  abstract removeClient(clientId: string): Observable<GetClientsResponse>;

  /**
   * Remove Member
   */
  abstract removeMember(memberId: string): Observable<GetMemberResponse>;
  /**
   * Create Client
   * @param client is the new client to create
   */
  abstract createClient(client: any): Observable<any>;

  /**
   * Member By Id
   */
  abstract getMemberById(memberId: string): Observable<GetMemberResponse>;
  /**
   * Update Member
   */
  abstract updateMember(
    member: Member,
    memberId: string
  ): Observable<GetMemberResponse>;

  /**
   * Add Member
   */
  abstract addMember(member: Member): Observable<GetMemberResponse>;

  /**
   * Add Member
   */
  abstract updateClient(
    client: Client,
    clientId: string
  ): Observable<GetClientsResponse>;

  /**
   * Get Pending Request By Client
   */
  abstract getPendingRequestsByMember(
    memberId: string
  ): Observable<GetAllRequestResponse>;
  /**
   * Get Pending Request By Client
   */
  abstract addMultipleMembers(members: Member[]): Observable<GetMemberResponse>;
  /**
   * Remove Member and Assign requests
   */
  abstract removeMemberAndAssign(
    data: RemoveAndAssignRequest
  ): Observable<GetMemberResponse>;
}
